import { OpportunityCandidateStatus } from 'src/constants/opportunity/enums'

export const CANDIDATE_TAB_TITLES: Record<OpportunityCandidateStatus, string> = {
  [OpportunityCandidateStatus.New]: 'New candidates',
  [OpportunityCandidateStatus.Offered]: 'Offered',
  [OpportunityCandidateStatus.Archived]: 'Archived',
}

export const CANDIDATE_PAGE_SIZE_OPTIONS = [25, 50, 100]

/**
 * GridTable does not forward paginationModel to the grid, so the grid keeps its own page size and the footer reads
 * that rather than ours. Starting anywhere other than the grid's own default of 100 makes the footer disagree with
 * what was actually fetched — it reports the full total as the visible range and disables paging, stranding every
 * row past the first page. Picking a size from the footer menu does sync both sides, so only the initial value has
 * to match.
 */
export const CANDIDATE_DEFAULT_PAGE_SIZE = 100

/**
 * Grid field to the sort column the API accepts. Sorting is server-side, so a field with no entry here stays
 * unsortable rather than silently sorting only the page in view.
 */
export const CANDIDATE_SORTABLE_COLUMNS: Record<string, string> = {
  name: 'firstName',
  vehicleType: 'vehicleType',
  createdAt: 'createdAt',
}
